export const minLengthRegex = /.{8,}/g;
export const minLengthMessage = 'At least 8 characters.';

export const maxLengthRegex = /.{20,}/g;
export const maxLengthMessage = 'Less than 20 characters.';

export const containsNumericRegex = /(\D*\d){2,}/g;
export const containsNumericMessage = 'At least 2 numbers (0-9).';

export const containsSpecialCharacterRegex = /[^`!@#$%^&*\-_=+'/.,]*[`!@#$%^&*\-_=+'/.,]/g;
export const containsSpecialCharacterMessage = "At least one special character (`!@#$%^&*-_=+'/.,).";

export const validatePassword = (password: string) => {
  const messages = [];

  if (!password.match(minLengthRegex)) {
    messages.push(minLengthMessage);
  }

  if (password.match(maxLengthRegex)) {
    messages.push(maxLengthMessage);
  }

  if (!password.match(containsNumericRegex)) {
    messages.push(containsNumericMessage);
  }

  if (!password.match(containsSpecialCharacterRegex)) {
    messages.push(containsSpecialCharacterMessage);
  }

  return messages.length > 0 ? `Password must have: ${messages.join(' ')}` : undefined;
};
